// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getData = createAsyncThunk('appProspections/getData', async ({ setBlock, ...params }) => {

  setBlock(true)

  const response = await axios.get('/apps/prospections', params)

  setBlock(false)

  return {
    params,
    data       : response.data.prospections,
    filterData : response.data.filterData,
    allData    : response.data.allData,
    totalPages : response.data.total
  }
})

export const appProspectionsSlice = createSlice({
  name: 'appProspections',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: []
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getData.fulfilled, (state, action) => {
      state.data       = action.payload.data
      state.filterData = action.payload.filterData
      state.allData    = action.payload.allData
      state.total      = action.payload.totalPages
      state.params     = action.payload.params
    })
  }
})

export default appProspectionsSlice.reducer
